import { ColorRadioOption } from "./ColorRadioOption";

export default ColorRadioOption;
